// src/pages/JoinGroupPage.js
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { db, auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const JoinGroupPage = () => {
  const [params] = useSearchParams();
  const groupId = params.get("groupId");
  const [message, setMessage] = useState("読み込み中...");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setMessage("ログインが必要です。");
        return;
      }

      if (!groupId) {
        setMessage("グループIDが見つかりません。");
        return;
      }

      const groupRef = doc(db, "shiftGroups", groupId);
      const groupSnap = await getDoc(groupRef);
      if (!groupSnap.exists()) {
        setMessage("グループが存在しません。");
        return;
      }

      const data = groupSnap.data();
      if (data.members.includes(user.email)) {
        setMessage("すでにこのグループに参加しています。");
        return;
      }

      await updateDoc(groupRef, {
        members: arrayUnion(user.email),
      });
      setMessage("✅ グループに参加しました！");
    });

    return () => unsubscribe();
  }, [groupId]);

  return (
    <div className="p-8 text-center">
      <h1 className="text-xl">{message}</h1>
    </div>
  );
};

export default JoinGroupPage;
